import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import AlertBanner from 'tio-ui/components/alert-banner';
import PageHeader from 'tio-ui/components/page-header';
import { VStack } from 'tio-ui/components/layout';

<template>
  {{pageTitle (t "idr.default")}}
  <VStack>
    <PageHeader @title={{t "idr.default"}}>
      <:below>
        {{! Present-tense bill alert (mirrors strategy-finder-0726), scoped to this
            pilot dashboard instead of the shared future-tense BudgetReconciliationBillAlert. }}
        <AlertBanner @intent="info" data-test-idr-0726-bill-alert>
          <h2 class="text-base">
            <strong>{{t "idr_dashboard_0726.bill_alert.header"}}</strong>
          </h2>
          <p>{{t "idr_dashboard_0726.bill_alert.body"}}</p>
        </AlertBanner>
      </:below>
    </PageHeader>
    {{outlet}}
  </VStack>
</template>
